import {
  card_styles_default
} from "./chunk.XXNYOEU5.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/card/card.ts
var FadvCard = class extends s {
  constructor() {
    super(...arguments);
    this.hasSlotController = new HasSlotController(this, "image", "header", "button", "icon");
  }
  handleFooterSlotChange() {
    var _a;
    const buttonSlot = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector('slot[name="button"]');
    [...buttonSlot.assignedElements()].filter((e) => hasTag(e, "fadv-button")).forEach((b) => {
      b.classList.add("footer--button");
    });
  }
  render() {
    return $`<div part="base" class=${o({
      card: true,
      "card--has-footer": this.hasSlotController.test("button"),
      "card--has-image": this.hasSlotController.test("image"),
      "card--has-header": this.hasSlotController.test("header"),
      "card--has-icon": this.hasSlotController.test("icon")
    })} ><div name="icon" class="card__icon"><slot name="icon"></slot></div><div class="card__content"><div part="header" class="card__header"><slot name="header"></slot></div><div part="image" class="card__image"><slot name="image"></slot></div><div part="body" class="card__body"><slot></slot></div><div part="footer" class="card__footer"><slot name="button" @slotchange=${this.handleFooterSlotChange}></slot></div></div></div>`;
  }
};
FadvCard.styles = card_styles_default;
FadvCard = __decorateClass([
  n("fadv-card")
], FadvCard);

export {
  FadvCard
};
